// shippingUtils.ts

/** Laptop / hardware request rows from shipping API (`itemTypeCode` 4). */
export function isLaptopRequestItem(item: { itemTypeCode?: string | number | null }): boolean {
  return String(item.itemTypeCode) === '4';
}

// API statuses mapping
export const statusMapping: Record<string, string | null> = {
  "Cancelled at K12": "Canceled",
  "Active": "Preparing to Ship",
  "Received by Vendor": "Preparing to Ship",
  "Shipped": "Shipped",
  "Canceled at Vendor": "Canceled",
  "Batched": "Preparing to Ship",
  "Held": "Preparing to Ship",
  "Suspended": "Canceled",
  "Back Ordered": "Delayed",
  "In Process": "Delayed",
  "Oversold": "Delayed",
  "Cancel Shipment": "Canceled",
  "Batched to Vendor": "Preparing to Ship",
  "Received": "Preparing to Ship",
  "Pending Return": "Pending Return",
  "Returned": "Returned",
  "Open Batch": "Preparing to Ship",

  // Hide Item
  "New Arrival": null,
  "Inactive": null,
  "HW Replaced": null,
  "Reassigned to Sibling": null,
  "Transferred": null,
  "Request Computer": null,
  "Decline Computer": null,
  "N/A": null,
  "NULL": null,
};

// Normalize
const normalizedStatusMapping: Record<string, string | null> = {};
Object.keys(statusMapping).forEach((key) => {
  normalizedStatusMapping[key.toLowerCase()] = statusMapping[key];
});


/**
 * Filters out hidden items and returns visible items.
 * @param items Shipping data array from API
 */
export const getVisibleShippingItems = (items: any[]) => {
  return items.filter((item) => {
    const rawStatus = item.status?.trim().toLowerCase() || "";
    if (rawStatus in normalizedStatusMapping) {
      return normalizedStatusMapping[rawStatus] !== null;
    }
    return true; // unknown statuses are visible
  });
};


/**
 * Returns the mapped or fallback status text
 * @param status Raw status from API
 */
export const getMappedStatus = (status: string) => {
  const rawStatus = status?.trim().toLowerCase() || "";
  if (rawStatus in normalizedStatusMapping) {
    return normalizedStatusMapping[rawStatus] ?? status;
  }
  return status;
};

/**
 * SmaillTip Shipping Tracking Information
 */
export const SHIPPING_MESSAGES = {
  TRACKING_UNAVAILABLE: {
    title: "Find your tracking information here.",
    description:
      'If available, statuses for each package of learning materials will appear here once processed. For more information, see the “When to Expect K12-Provided Materials” section below.',
  },
};